import React from "react";
import {CustomTab, TabRow} from "../CustomerHomePageWithShiftScore.styles";
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    ExclamationCircleOutlined,
    HistoryOutlined,
    FieldTimeOutlined
} from "@ant-design/icons";
import {useStore} from "hooks/useStore";
import {useTranslation} from "react-i18next";

const NavigationButtons = ({
    tabKey,
    changeTab,
    data,
    futureData,
    pastData,
    count,
    objectionsCount,
    setIsObjectionsModalOpen,
    setApplyWaitingApproveFilters,
    isWaitingApproveActive,
    originalActiveData
}) => {
    const stores = useStore();
    const {t} = useTranslation();

    return (
        <TabRow className="navigation-buttons-row">
            <CustomTab
                isActive={tabKey === "activeShifts" && !isWaitingApproveActive}
                onClick={() => changeTab("activeShifts")}
                className="navigation-button"
            >
                <div>
                    <ClockCircleOutlined />
                    <div>{originalActiveData?.dataCount || 0}</div>
                    <div style={{fontSize: "12px", flexWrap: "wrap"}}>Aktif Vardiyalar</div>
                </div>
            </CustomTab>
            <CustomTab
                isActive={tabKey === "futureShifts"}
                onClick={() => changeTab("futureShifts")}
                className="navigation-button"
            >
                <div>
                    <HistoryOutlined />
                    <div>{futureData?.dataCount || 0}</div>
                    <div style={{fontSize: "12px"}}>Planlanan Vardiyalar</div>
                </div>
            </CustomTab>
            <CustomTab
                isActive={tabKey === "pastShifts"}
                onClick={() => changeTab("pastShifts")}
                className="navigation-button"
            >
                <div>
                    <FieldTimeOutlined />
                    <div>{pastData?.dataCount || 0}</div>
                    <div style={{fontSize: "12px"}}>Tamamlanan Vardiyalar</div>
                </div>
            </CustomTab>

            {/* Action Buttons */}
            {stores.meStore.checkRole("isCompanyUser") && (
                <CustomTab
                    isActive={isWaitingApproveActive}
                    iconBgColor="#fa8c16"
                    iconColor="white"
                    onClick={() => setApplyWaitingApproveFilters(true)}
                    className="navigation-button"
                >
                    <div>
                        <CheckCircleOutlined />
                        <div style={{fontWeight: "bold"}}>{count || 0}</div>
                        <div style={{fontSize: "12px"}}>
                            {t("shiftScore.shiftStatuses.waitingApprove", {ns: "shiftScore"})}
                        </div>
                    </div>
                </CustomTab>
            )}

            <CustomTab
                isActive={false}
                iconBgColor="#cf1322"
                iconColor="white"
                onClick={() => setIsObjectionsModalOpen(true)}
                className="navigation-button"
            >
                <div>
                    <ExclamationCircleOutlined />
                    <div style={{fontWeight: "bold"}}>{objectionsCount || 0}</div>
                    <div style={{fontSize: "12px"}}>
                        {t("screens.shiftReportObjections", {ns: "common"})}
                    </div>
                </div>
            </CustomTab>
        </TabRow>
    );
};

export default NavigationButtons;
